import React from 'react';
import { Provider } from 'react-redux';
import { Route, HashRouter, Switch, Redirect } from 'react-router-dom';

import 'sanitize.css/sanitize.css';
import './styles/main.scss';

import AppContainer from './containers/AppContainer/AppContainer';

import { store } from './store';

import { ScrollToTop } from './components/ScrollToTop';
import { AccountPage } from './containers/Account/AccountPage';
import { isUserAuthenticated } from './utils/helpers';
import { getRoutes } from './utils/routes';

const PrivateRoute = ({ component: Component, path }: any) => {
	return <Route
		exact
		path={path}
		render={(props: any) =>
			isUserAuthenticated()
				? <AccountPage><Component {...props} /></AccountPage>
				: <Redirect to={`${window.location.origin}/tili/kirjaudu?redirect=${props.history.location.pathname}`} />
		} />
};

const routes = getRoutes().map((route) => (
	(route.private === true)
		? <PrivateRoute path={route.path} component={route.component} />
		: <Route exact={(route.path !== '*')} path={route.path} component={route.component} />
));

const App = () => {
	return (
		<Provider store={store as any}>
			<HashRouter>
				<AppContainer>
					<ScrollToTop />
					<Switch children={routes} />
				</AppContainer>
			</HashRouter>
		</Provider>
	);
};

export default App;
